import { render, staticRenderFns } from "./TopTenRedeem.vue?vue&type=template&id=fefdeed4&scoped=true&"
import script from "./TopTenRedeem.vue?vue&type=script&lang=js&"
export * from "./TopTenRedeem.vue?vue&type=script&lang=js&"
import style0 from "./TopTenRedeem.vue?vue&type=style&index=0&id=fefdeed4&scoped=true&lang=css&"
import style1 from "./TopTenRedeem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefdeed4",
  null
  
)

export default component.exports